import tw from 'twin.macro'

export const Container = tw.div`
  flex-1
  flex
  flex-wrap
  gap-[8px]
`
